/* vault 入库申请 */

import commonEventJs from '@/common/CommonEventJs';

import { getInfo, signAgreement, getTime, setUTC } from "@/api/public";

import UploadImages from '@/components/upload-images';
export default {
    components: { UploadImages },
    data() {
        return {
            loading: false,
            vaultWareId: '',
            valutType: 0,//0：在库未上架，1：在库竞拍 2：在库一口价，3 出库 ，4 售出
            tabType: 2,//1入库 2在库 3出库

            userInfo: getInfo(),
            token: getInfo().ChineseToken, // 用户token
            MemberId: getInfo().MappingUserId, // 用户ID 
            UserId:getInfo().Id,  // 海外ID用户ID
            MemberMobile: getInfo().TelPhone,
            MemberRealName: getInfo().NickName,
            MemberSource: getInfo().MemberSource,

            urlParams: {},//URL 参数
            showType: '',//显示详情的状态：edit编辑
            vaultList: [],

            step1: 0,
            step2: 0,
            submitLoading: false,

            ratingOptions: [{
                value: 'PSA',
                label: 'PSA'
            }, {
                value: 'BGS',
                label: 'BGS'
            }, {
                value: 'CGC',
                label: 'CGC'
            }, {
                value: 'CCIC',
                label: 'CCIC'
            }, {
                value: 'GBTC',
                label: 'GBTC'
            }],

            FormData: {
                MemberId: getInfo().MappingUserId,
                ReturnConsigneeAddress: {},//=>FormStep2
            },
            FormStep1: {
                ValutId: '',
                Imgs: [],
                Details: [],
                Remark: ''
            },
            cardDetails: [
                { Id: null, ProfessionalGrader: "", CertificationNumber: null }
            ],//FormStep1->Details
            parentPicList: [],//FormStep1->Imgs picList
            picListLimit: 12,//图片上传限制
            maxCardCount: 50,//最多可添加卡片数
            cardHaveRepeated: [],//卡片是否有重复
            rules1: {
                ValutId: [{ required: true, trigger: ['change', 'blur'], message: this.$t('rules.SelectVault') }],
            },//验证规则
            FormStep2: {
                Contacts: '',
                Phone: '',
                Province: '',
                Address: ''
            },
            rules2: {
                Contacts: [{ required: true, trigger: ['change', 'blur'], message: this.$t('rules.enterAddress') }]
            },//验证规则
            //地址相关
            addressList: [],
            dialogAddressVisible: false,
            addrLoading: false,
            addrType: '',//地址编辑类型 edit:修该地址
            addrId: '',//当前地址ID
            currentRowKey: null,
            currentRowData: {},
            addrSubmitLoading: false,

            //查看详情
            dialogDetailVisible: false,
            itemDetail: {},//对象详情
            activeTabName: 'first',
            currentPreviewIndex: 0,//预览图当前键值
            previewVisible: false,


            //查看问题卡片信息
            dialogCheckCardInfoVisible: false,
            //物流轨迹
            expressLoading: false,
            expressDetail: '',// 快递详情
            isExpress: false,// 物流信息弹框 

            //发货相关
            dialogShipVisible: false,
            ShipForm: { Id: '' },
            shipFormSelVal: null,//已选中的快递对象
            expressList: [],//快递公司列表
            expressListAll: [],//快递公司列表[全部的]
            rulesShip: {
                LogisticsCompany: [{ required: true, trigger: ['change', 'blur'], message: this.$t('vault.SelectCarrier') }],
                TrackingNumber: [{ required: true, trigger: ['change', 'blur'], message: this.$t('vault.EnterTrackingNumber') }],
                Phone: [{ required: true, trigger: ['change', 'blur'], message: this.$t('vault.EnterPhoneNumber') }],
            },


            //协议
            vaultAgreement: false,//是否同意协议
            vaultAgreementType: 22,
            ...window.myUploadData,

            //地址 物流相关 by qian
            vaultItemAddress: [],
            stepsUp:true

        }
    },
    watch: {
        FormStep1: {
            handler(newVal, oldVal) {
                //console.log('watch-FormStep1', newVal)
                if (newVal.ValutId && newVal.Imgs.length && newVal.Details.length) {
                    this.step1 = 1;
                } else {
                    this.step1 = 0;
                }
            },
            deep: true
        },
        FormStep2: {
            handler(newVal, oldVal) {
                //console.log('watch-FormStep2', newVal)
                if (newVal.Contacts && newVal.Phone && newVal.Province && newVal.Address) {
                    this.step2 = 1;
                } else {
                    this.step2 = 0;
                }
            },
            deep: true
        },
        cardDetails: {
            handler(newVal, oldVal) {
                var that = this;
                //console.log("picList-newVal", newVal)
                //console.log("picList-oldVal", oldVal)
                var hasEmptyVal = false;//是否存在未填值
                //cardHaveRepeated
                if (newVal.length) {
                    newVal.map(item => {
                        if (!item.ProfessionalGrader || !item.CertificationNumber) {
                            hasEmptyVal = true;
                        }
                    });
                    //排查重复卡片编号
                    that.cardHaveRepeated = newVal.reduce((acc, item, index) => {
                        const duplicates = newVal.filter((it, idx) =>
                            it.ProfessionalGrader === item.ProfessionalGrader && it.ProfessionalGrader && it.CertificationNumber === item.CertificationNumber && it.CertificationNumber && idx !== index
                        );
                        if (duplicates.length > 0 && !acc.includes(index)) {
                            acc.push(index);
                        }
                        return acc;
                    }, []).sort((a, b) => a - b);

                    console.log('cardHaveRepeated', that.cardHaveRepeated);
                }
                this.$set(this.FormStep1, 'Details', newVal);
                if (!hasEmptyVal) {
                    try {
                        this.$refs.AddStockInForm1.clearValidate(['Details']);
                    } catch (err) { }
                }
            },
            deep: true
        },
        vaultItemAddress: {
            handler(newVal, oldVal) {
                if (newVal == oldVal) return
                this.getExpress(newVal)
            },

            deep: true
        },


        showType: {
            handler(newVal) {
                const that = this;
                console.log(newVal, 'newVal', that.vaultList.length)
                if (newVal && newVal != 'view' && that.vaultList.length <= 0) {

                    this.GetAllValutByPage()//仓库列表
                }
            },
            immediate: true,
            deep: true
        },
    },
    created: function () {
        var that = this;
        that.urlParams = this.$route.query;
        that.userInfo = getInfo();
        that.MemberSource=that.userInfo.MemberSource
        that.FormData.MemberId=that.userInfo.MappingUserId
        //this.$commonEventJs.getUrlParams();
        //console.log('urlParams', that.urlParams);

        //图片上传配置
        // that.picListLimit = 12;
        // that.imgLabelVal = ''
        // that.imgShowKey = false;
    },
    mounted: function () {
        var that = this;

        if (that.$route.params.id) {
            that.vaultWareId = that.$route.params.id
        }

        //this.GetAllValutByPage()//仓库列表
        var urlParams = that.urlParams;
        console.log(that.urlParams, 'that.urlParams')
        that.showType = urlParams.type || 'add';
        if (urlParams.from == 'card') {
            that.GetCardDetail(urlParams.id)//卡淘商品详情
        } else {
            if (urlParams.id) {
                that.GetDetail(urlParams.id)//商品详情
            }
        }
        that.GetExpressShipper()
    },
    computed: {
        orderStatus() {
            return [
                { value: '', label: this.$t('base.all') },
                { value: 0, label: this.$t('vault.AwaitingShipment') },
                { value: 1, label: this.$t('vault.AwaitingDelivery') },
                { value: 2, label: this.$t('vault.AwaitingInspection') },
                { value: 3, label: this.$t('vault.InspectionComplete') },
                { value: 5, label: this.$t('vault.AwaitingReturn') },
                { value: 6, label: this.$t('vault.Returned') },
                { value: 99, label: this.$t('vault.VerificationFailed') }
            ]
        },
        orderStatusSet() {
            return function (id) {
                const that = this;
                if (id != null) {
                    return that.orderStatus.filter(val => val.value === id)[0].label;
                }
            }
        },
        cardStatus() {
            return [
                { value: '', label: this.$t('base.all') },
                { value: 0, label: this.$t('vault.Notinspected') },
                { value: 2, label: this.$t('vault.InspectionPassed') },
                { value: 99, label: this.$t('vault.InspectionFailed')}
            ]
        },
        cardStatusSet() {
            return function (id) {
                const that = this;
                if (id != null) {
                    return that.cardStatus.filter(val => val.value === id)[0].label;
                }
            }
        },
        setTime() {
            return function (val) {
                return getTime(val, -8, '', 'cn')
            }
        },
        ThousandAndDecimal() {
            return function (num) {
                //金额千分位
                var val = "";
                if (num) {
                    val = parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                }
                return val
            }
        },
        formRule: function () {
            var that = this;
            return function (required, ControlName, name) {
                var r = [];
                var exg = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/;//大于0且保留小数两位
                if (required) {
                    if (ControlName == 'Imgs') {
                        r = [
                            {
                                validator: function (rule, value, callback) {
                                    var _val = that.FormStep1[ControlName] ? that.FormStep1[ControlName] : [];
                                    if (!_val || _val.length <= 0) {
                                        callback(new Error(that.$t('vault.PleaseUploadImages')));
                                    } else {
                                        // 验证通过
                                        callback();
                                    }
                                }, trigger: ['change', 'blur']
                            }
                        ];
                    } else if (ControlName == 'Details') {
                        r = [
                            {
                                validator: function (rule, value, callback) {
                                    var _val = that.FormStep1[ControlName] ? that.FormStep1[ControlName] : [];
                                    if (_val.length) {
                                        var hasEmptyVal = false;//是否存在未填值
                                        _val.map(item => {
                                            if (!item.ProfessionalGrader || !item.CertificationNumber) {
                                                hasEmptyVal = true;
                                            }
                                        });
                                        if (hasEmptyVal) {
                                            callback(new Error(' '));//
                                        } else {
                                            // 验证通过
                                            callback();
                                        }
                                    } else {
                                        callback(new Error(' '));//new Error('请完善卡片信息')
                                    }
                                }, trigger: ['blur']
                            }
                        ];
                    }
                }
                return r;
            }
        },
        checkReturnCard() {
            return function (data) {
                let hasStatus = false;
                hasStatus = data['Details'].some(item => item.ReturnInfoId);
                //const hasStatus = data['Details'].some(item => item.Status === 99);
                //if((data.VerifyImg&&data.VerifyImg.length)||(data.VerifyVideo&&data.VerifyVideo.length))  hasStatus=true;
                return hasStatus
            }
        },
    },
    methods: {
        gotoContact() {
            this.$root.$emit("contactUS", true);
        },
        setPicList(newVal) {
            let that = this;
            console.log('setPicList', newVal);
            var Imgs = [];
            if (newVal.length) {
                Imgs = newVal.map(item => item.ImageUrl);
                //console.log("Imgs", Imgs)
            }
            this.$set(this.FormStep1, 'Imgs', Imgs);
            if (Imgs.length > 0) {
                try {
                    this.$refs.AddStockInForm1.clearValidate(['Imgs']);
                } catch (err) { }
            }
        },
        //#region 入库申请
        addRating() {
            this.cardDetails = [...this.cardDetails, { Id: null, ProfessionalGrader: "", CertificationNumber: "" }]
        },
        delRating(obj, key) {
            this.cardDetails = this.cardDetails.filter((item, index) => index !== key);
        },
        GetAllValutByPage() {
            /* 获取仓库列表 */
            var that = this;
            const formData = {
                PageIndex: 1,
                PageSize: 100,
                AreaCode: that.MemberSource
            }
            const fun = function (res) {
                console.log("GetAllValutByPage", res);
                if (res.Result == 1) {
                    that.vaultList = res.Data || [];
                    that.$set(that.FormStep1, "ValutId", res.Data[0]['_id']);
                } else {
                    that.vaultList = []
                    that.$set(that.FormStep1, "ValutId", '');
                }
            }
            that.$get(that.$interface['GetAllValutByPage'], formData).then(res => {
                fun(res)
            })
        },
        handleBackList() {
            var that = this;
            that.$router.push({
                path: '/vault/StockInMgt/'+that.FormStep1.ValutId
            })
            //location.href = '/vault/StockInMgt';
        },
        //查看详情相关
        changeToEdit(type) {
            this.showType = type || 'view';
        },
        FormSubmit(submitType) {
            /* 添加、编辑寄存订单 */
            var that = this;

            var saveType = that.showType;
            if (that.cardHaveRepeated.length) {
                that.$message.warning({ message: that.$t('vault.PleaseCardInfo'), offset: "400" })
                that.submitLoading = false;
                return false
            }

            //第二步
            const step2Fun = function () {
                //console.log('FormStep2', that.FormStep2)
                that.$refs.AddStockInForm2.validate(valid => {
                    if (valid) {

                        if (!that.vaultAgreement && that.showType != 'edit') {
                            that.$message.warning({ message: that.$t('vault.PleaseVaultStorageAgreement'), offset: "500" })
                            return false
                        }
                        if (that.submitLoading) { return }

                        const newFormData = {
                            Id: that.FormStep1['_id'] || "",
                            ...that.FormData,
                            ...that.FormStep1,
                            ReturnConsigneeAddress: { ...that.FormStep2 }
                        }

                        var keepFields = ['Details', 'Imgs', 'ReturnConsigneeAddress', 'ValutId', 'MemberId']// 'Remark',
                        if (saveType == 'edit') {
                            keepFields = ['Details', 'Imgs', 'ReturnConsigneeAddress', 'ValutId', 'MemberId', 'Id']//'Remark', 
                        }
                        var AuthForm = commonEventJs.FormToAuth(newFormData, {
                            keepFields: keepFields,
                            keepNestedFields: {
                                ReturnConsigneeAddress: ['Address', 'Contacts', 'Phone', 'Province'],
                            },
                            keepArrayItemFields: {
                                Details: ['ProfessionalGrader', 'CertificationNumber']//'Id', 
                            }
                        });

                        //console.log('newFormData', newFormData)
                        console.log('AuthForm', AuthForm)
                        if (submitType == 'test') {
                            return false
                        }
                        //console.log('submitType', submitType)

                        that.$confirm(that.$t('vault.ConfirmCardInfo'), that.$t('base.hint'), {
                            confirmButtonText: that.$t('base.confirm'),
                            cancelButtonText: that.$t('base.cancel'),
                            type: 'warning'
                        }).then(() => {
                            that.submitLoading = true;
                            //that.StorageCreate(newFormData);//创建寄存订单

                            if (that.showType != 'edit') {
                                signAgreement(that.vaultAgreementType);//提交协议
                            }


                            const fun = function (res) {
                                //console.log("StorageCreate", res);
                                if (res.Result == 1) {
                                    that.$message.success(that.$t('base.Deletedsuccessfully'));
                                    //that.FormStep1.ValutId
                                    that.$router.push({
                                        path: '/vault/StockInMgt/' + that.FormStep1.ValutId
                                      })
                                    //location.href = '/#/vault/StockInMgt';
                                } else {
                                    that.$message.error(res.Msg);
                                    that.submitLoading = false;
                                }
                            }
                            if (that.showType == 'edit') {
                                that.$post(that.$interface['StorageEdit'], AuthForm.data).then(res => {
                                    fun(res)
                                })
                            } else {
                                that.$post(that.$interface['StorageCreate'], AuthForm.data).then(res => {
                                    fun(res)
                                })
                            }
                        }).catch(() => { });

                    } else {
                        that.$message.warning({ message: that.$t('base.CompleteContent'), offset: "400" })
                        that.submitLoading = false;
                        return false
                    }
                })
            }


            //第一步
            console.log('FormStep1', that.FormStep1)
            const step1Fun = function () {
                that.$refs.AddStockInForm1.validate(valid => {
                    if (valid) {
                        step2Fun();//that.addSiStepStatus = 1;//完成第一步
                    } else {
                        that.$message.warning({ message: that.$t('base.CompleteContent'), offset: "400" })
                        return false
                    }
                })
            }
            step1Fun();
            //endregion
        },
        //#endregion 入库申请
        //详情相关
        GetDetail(Id) {
            var that = this;
            var urlParams = that.urlParams;
            Id = Id ? Id : (urlParams.id ? urlParams.id : '');
            if (!Id) return

            const formData = { Id }
            that.loading = true;
            const fun = function (res) {
                //console.log("GetDetail", res);
                if (res.Result == 1 && res.Data) {
                    that.showEdit(res.Data)
                } else {

                }
                that.loading = false;
            }
            that.$post(that.$interface['GetVaultDetail'], formData).then(res => {
                fun(res)
            })
        },
        GetCardDetail(Id) {
            var that = this;
            var urlParams = that.urlParams;
            Id = Id ? Id : (urlParams.id ? urlParams.id : '');
            if (!Id) return

            const formData = { Id }
            that.loading = true;
            const fun = function (res) {
                //console.log("GetCardDetail", res);
                if (res.Result == 1 && res.Data) {
                    that.GetDetail(res.Data)
                } else {
                    that.loading = false;
                }
            }
            that.$get(that.$interface['GetStorageOrderByCardOrderId'], formData).then(res => {
                fun(res)
            })
        },
        showEdit(itemData) {
            /* 获取申请记录详情 */
            /*itemData:当前数据
            *type：view查看，edit编辑
            */
            var that = this;

            //#region 数据重组 第一步
            //图片
            var pl = [];
            itemData['Imgs'].map((item, k) => {
                var obj = {
                    id: new Date().getTime() + '-' + k,
                    ImageUrl: item,
                    ImageSort: k
                };
                pl.push(obj);
            })
            that.parentPicList = pl;//picList -> my-upload.js
            if (that.$refs.UploadImages) {
                // that.$refs.UploadImages.setPic2Form(pl);
            }

            //评级卡
            that.cardDetails = itemData.Details
            //赋值FormStep1
            that.FormStep1 = {
                ...itemData,
            };
            //console.log('FormStep1', that.FormStep1);
            //#endregion

            var addressReturn = itemData.ReturnInfos[0];
            that.vaultItemAddress = itemData.ReturnInfos[0]
            //var CityIds = [addressReturn.Province || '', addressReturn.City || '', addressReturn.District || ''];
            //var CityNames = [addressReturn.Province || '', addressReturn.City || '', addressReturn.District || ''];

            this.dialogAddSIVisible = true;
            that.FormStep2 = {
                ...addressReturn,
            };

            //退回地址中遍历对应退回的卡片【详情显示】
            var returnCard = {};
            try {
                itemData.Details.forEach(item => {
                    // 只处理有 ReturnInfoId 的数据
                    if (item.ReturnInfoId) {
                        var returnId = `${item.ReturnInfoId}`;
                        // 如果这个 ReturnInfoId 还不存在，创建空数组
                        if (!returnCard[returnId]) {
                            returnCard[returnId] = [];
                        }
                        // 将当前对象添加到对应的数组中
                        returnCard[returnId].push(item);
                    }
                });
            } catch (err) { }
            itemData['ReturnCard'] = returnCard;

            //console.log('itemData', itemData);
            if (itemData.Status != 0) {
                that.showType = 'view';
            }
            //itemData.Status<=3&&
            if (itemData.LogisticsCompany && itemData.TrackingNumber) {
                if (itemData.Status <= 3) {
                    console.log(1)
                    that.getExpress(itemData)
                } else if (itemData.Status == 5 || itemData.Status == 6) {
                    console.log(2)
                    that.getExpress(that.vaultItemAddress)
                }
            }
            that.itemDetail = itemData;

        },
        handlePreview(index) {
            this.currentPreviewIndex = index;
            this.previewVisible = true;
        },
        //地址相关
        GetMyAddress() {
            /* 获取地址列表 */
            var that = this;
            const formData = {
                MemberId: that.userInfo.Id,
                lag: "en",
                // token: that.token,
                PageIndex: 1,
                PageSize: 100
            }
            console.log('GetMyAddress-formData', formData)
            that.addrLoading = true;
            //?memberid=&Pagesize=&pageIndex=1&token=&appname= &device=&version=&lag=zh&mbname=&operator_id=
            const fun = function (res) {
                console.log("GetMyAddress", res);
                if (res.Result == 1) {
                    that.addressList = res.Data || [];
                } else {
                    that.addressList = []
                }
                that.addrLoading = false;
            }
            //commonEventJs.Request('GetMyAddress', AuthForm.data, fun, "GET", AuthForm.auth);
            that.$get(that.$interface['SearchShippingAddresses'], formData).then(res => {
                fun(res)
            })
        },
        handleRowClick(row, column, event) {
            var that = this;
            console.log('handleRowClick', row, column, event)
            this.currentRowKey = row.Id
            var data = {
                Contacts: row.UserName,
                Phone: row.Phone,
                Province: row.Country + ' ' + row.StateCode + ' ' + row.City,
                Address: row.StreetAddress + (row.StreetAddress2 ? ' (' + row.StreetAddress2 + ')' : ''),
                Address1: row.StreetAddress,
                Address2: row.StreetAddress2 || ''
            }
            if (that.addrType == 'edit') {
                //修改地址
                that.currentRowData = { ...data, Id: that.itemDetail._id, ReturnInfoId: that.addrId };
                //console.log("that.currentRowData",that.currentRowData)
            } else {
                that.FormStep2 = data;
                that.handleAddressClose();
            }
        },
        editAddress() {
            //修改地址
            var that = this;
            if (that.currentRowData.Contacts) {
                if (that.addrSubmitLoading) return
                that.addrSubmitLoading = true;
                const fun = function (res) {
                    console.log("EditReturnInfo", res);
                    if (res.Result == 1) {
                        that.handleAddressClose()
                        that.GetDetail();
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.addrSubmitLoading = false;
                }
                let formData = { ...that.currentRowData };
                delete formData.Address1
                that.$post(that.$interface['EditReturnInfo'], formData).then(res => {
                    fun(res)
                })
            }
        },
        addNewAddress() {
            var that = this;
            window.open('/#/mycardhobby/setting', '_blank');
            that.handleAddressClose();
        },
        showMyAddress(type, addrId) {
            console.log(type, addrId, 'showMyAddress');
            this.dialogAddressVisible = true
            this.addrType = type || '';
            this.addrId = addrId || '';
            this.GetMyAddress();//地址列表
        },
        handleAddressClose() {
            this.dialogAddressVisible = false
            this.addrType = '';
            this.addrId = '';
            this.currentRowData = {};
        },
        //查看问题卡片信息相关
        checkReturnInfo() {
            var that = this;
            var itemDetail = that.itemDetail;
            that.dialogCheckCardInfoVisible = true;
        },
        handleCheckCardInfoClose() {
            var that = this;
            that.dialogCheckCardInfoVisible = false;
        },
        //查看物流
        getExpress(itemData) {
            let that = this
            if (that.expressLoading) return
            that.expressLoading = true;
            //that.isExpress = true;
            var _data = {
                OrderId: itemData.Id || itemData._id,
                ShipperCode: itemData.LogisticsCompanyCode, //公司编号
                LogisticCode: itemData.TrackingNumber //公司编号
            }
            const fun = function (res) {
                if (res.Result == 1) {
                    const Tracklist = res.Data && res.Data[0] ? res.Data[0].Tracklist : {}
                    that.expressDetail = {
                        TrackingNumber: itemData.TrackingNumber,
                        LogisticsCompany: itemData.LogisticsCompany,
                        ...Tracklist
                    }
                    //console.log("getExpress", that.expressDetail);
                } else {
                    that.expressDetail = {};
                }
                that.expressLoading = false;
            }
            that.$post(that.$interface['GetExpressSubscribeInfo'], _data).then(res => {
                fun(res)
            })
        },
        //发货相关  获取物流公司列表
        GetExpressShipper() {
            /*获取快递公司和编码*/
            var that = this;
            var localList = localStorage.getItem('Card_ExpressShipper') ? JSON.parse(localStorage.getItem('Card_ExpressShipper')) : '';
            var cookieExpress = that.$cookie.get("Card_ExpressShipper");
            if (cookieExpress && localList && localList.length) {
                that.expressList = localList;
                that.expressListAll = localList;
            } else {
                const fun = function (res) {
                    that.expressList = res.Data;
                    that.expressListAll = res.Data;
                    localStorage.setItem('Card_ExpressShipper', JSON.stringify(res.Data))
                    that.$cookie.set("Card_ExpressShipper", true, { expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000), path: '/' });
                }
                that.$get(that.$interface['GetExpressShipper'], '').then(res => {
                    fun(res)
                })
            }
        },
        showShipDialog(obj) {
            var that = this;
            console.log("showShipDialog", obj)
            that.dialogShipVisible = true;
            that.$set(that.ShipForm, 'Id', obj._id);
            if (obj.LogisticsCompanyCode) {
                that.shipFormSelVal = obj.LogisticsCompanyCode;
            }
            if (obj.TrackingNumber) {
                that.$set(that.ShipForm, 'TrackingNumber', obj.TrackingNumber);
            }
        },
        handleShipClose() {
            var that = this;
            that.dialogShipVisible = false;
            that.$set(that.ShipForm, 'LogisticsCompanyCode', '');
            that.$set(that.ShipForm, 'LogisticsCompany', '');
        },
        handleChangeExp(event) {
            var that = this;
            //console.log('handleChangeExp', event)
            that.$set(that.ShipForm, 'LogisticsCompanyCode', event.ShipperCode);
            that.$set(that.ShipForm, 'LogisticsCompany', event.ShipperName);
        },
        ShipSubmit(submitType) {
            /* 填写发货单 */
            var that = this;
            this.$refs.ShipFormRef.validate(valid => {
                if (valid) {
                    if (that.submitLoading) { return }

                    // var AuthForm = commonEventJs.FormToAuth();
                    //console.log('AuthForm', AuthForm)

                    if (submitType == 'test') {
                        return false
                    }

                    this.$confirm(that.$t('vault.ConfirmCardInfo'), that.$t('base.hint'), {
                        confirmButtonText: that.$t('base.confirm'),
                        cancelButtonText: that.$t('base.cancel'),
                        type: 'warning'
                    }).then(() => {
                        that.submitLoading = true;
                        const fun = function (res) {
                            //console.log("StorageCreate", res);
                            if (res.Result == 1) {
                                that.$message.success(that.$t('base.Submittedsuccessfully'));
                                that.dialogShipVisible = false;
                            } else {
                                that.$message.error(res.Msg);
                            }
                            that.submitLoading = false;
                            that.GetDetail();
                        }
                        that.$post(that.$interface['ShipOrder'], that.ShipForm).then(res => {
                            fun(res)
                        })
                    }).catch(() => { });

                } else {
                    that.$message.warning(that.$t('vault.PleaseRequiredInfo'))
                    that.submitLoading = false;
                    return false
                }
            })
        },
        //协议
        ifAgreement(agreeId) {
            var that = this;
            let isAgree = true;// !this.vaultAgreement;
            if (!this.vaultAgreement) {
                this.vaultAgreement = isAgree;
                 //signAgreement(that.vaultAgreementType);//提交协议
            }
        }
    },
    destroyed: function () {
        var that = this;
    }
}


// WEBPACK FOOTER //
// ./src/pages/Vault/js/vue-VaultStockInApply.js